import {useSelector} from 'react-redux';

export function useStateContainerName(): string {
    return useSelector((state) => state.settings.containerName);
}

export function useStateContainerFacets(): string[] {
    const containerName = useSelector((state) => state.settings.containerName);
    return useSelector((state) => state.settings.containers[containerName]?.facetFields);
}
